module.exports = __webpack_public_path__ + "img/flow.ar.e39da918.png";